module.exports = __webpack_public_path__ + "img/69.d7d1e481.jpg";